export default __webpack_public_path__ + "static/media/iic2.91f0c4a3.JPG";